import {useAppDispatch} from "@/lib/store.ts";
import {upsertRoom} from "@/app/user/messages/messages.slice.ts";
import {ChatService} from "@/services/chat.service.ts";
import {useNavigate} from "react-router";
import {upsertUsers} from "@/lib/store/users.slice.ts";
import {Contact} from "@/models/chat.model.ts";

export function useStartDM() {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const startDM = async (contact: Contact) => {
        const room = await ChatService.findOrCreateDM(contact.id);
        dispatch(upsertUsers([{id: contact.id, name: contact.name, image: contact.avatar ?? undefined}]));

        dispatch(upsertRoom(room));
        navigate(`/messages/${room.id}`);
    };

    return {startDM};
}